import React from 'react';

import { bookmarks_path } from '@routes';

import { BOOKMARKS } from './constants';

interface BookmarkAddedToastProps {
  onToastClick: () => void;
}

const BookmarkAddedToast = ({ onToastClick }: BookmarkAddedToastProps) => (
  <>
    Added to your reading list on the{' '}
    <a href={bookmarks_path()} onClickCapture={onToastClick}>
      {BOOKMARKS}
    </a>{' '}
    page
  </>
);

export default BookmarkAddedToast;
